import { render, staticRenderFns } from "./VideoFilterValueChip.vue?vue&type=template&id=18dea38a&"
import script from "./VideoFilterValueChip.vue?vue&type=script&lang=js&"
export * from "./VideoFilterValueChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports